import isNil from 'lodash/isNil';
import isString from 'lodash/isString';
import isNumber from 'lodash/isNumber';
import isObject from 'lodash/isObject';
import isBoolean from 'lodash/isBoolean';
import get from 'lodash/get';
import { timeParser, dateParser, dateTimeParser } from './DateTimeParsers';

export type TypeCheckTypes =
  | 'integer'
  | 'decimal'
  | 'string'
  | 'text'
  | 'quantity'
  | 'coding'
  | 'boolean'
  | 'time'
  | 'date'
  | 'dateTime'
  | 'attachment';

export const typeCheckTypes: TypeCheckTypes[] = [
  'integer',
  'decimal',
  'string',
  'text',
  'quantity',
  'coding',
  'boolean',
  'time',
  'date',
  'dateTime',
  'attachment',
];

const booleanCheck = (value: any) => isBoolean(value);
const integerCheck = (value: any) => isNumber(value) && value % 1 === 0;
const decimalCheck = (value: any) => isNumber(value);
const stringCheck = (value: any) => isString(value);
const timeCheck = (value: any) => timeParser.isValid(value);
const dateCheck = (value: any) => dateParser.isValid(value);
const dateTimeCheck = (value: any) => dateTimeParser.isValid(value);
const quantityCheck = (value: any) => {
  if (!isObject(value)) return false;

  const quantityValue = get<fhir.Quantity, 'value'>(value, 'value');
  return isNil(quantityValue) || isNumber(quantityValue);
};
const codingCheck = (value: any) => isObject(value);
const attachmentCheck = (value: any) =>
  isObject(value) && !!(value as fhir.Attachment)?.url;

export default (
  type: TypeCheckTypes,
  value: any,
  isNilValid: boolean = true,
) => {
  const valueNil = isNil(value);

  if (valueNil) return isNilValid;

  switch (type) {
    case 'boolean':
      return booleanCheck(value);
    case 'integer':
      return integerCheck(value);
    case 'decimal':
      return decimalCheck(value);
    case 'string':
      return stringCheck(value);
    case 'text':
      return stringCheck(value);
    case 'quantity':
      return quantityCheck(value);
    case 'coding':
      return codingCheck(value);
    case 'time':
      return timeCheck(value);
    case 'date':
      return dateCheck(value);
    case 'dateTime':
      return dateTimeCheck(value);
    case 'attachment':
      return attachmentCheck(value);
    default:
      console.error(`Received unsupported type "${type}" for type check`);
  }
};
